export default {
  auth0: {
    domain: "jointable.ca.auth0.com",
    clientId: "JlzuYQeQF8p1HxHt29r6zIxZwsN1VJuq",
    audience: "jointable.ca",
  },
}
